export default __webpack_public_path__ + "static/media/DANTE.6be121ac.png";